import { E3Farm } from '@e3dc-react/icons'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Typography, Box, useMediaQuery, useTheme } from '@mui/material'
import React from 'react'

/**
 * Retrofit not available content for Farm Master
 */
const FarmMasterWarning: React.FC = () => {
  const { t } = useCustomTranslation()
  const theme = useTheme()
  const downMd = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <E3Farm sx={{ width: 30, height: 30, mr: 2, color: 'primary.main' }} />
        <Typography variant={downMd ? 'h4' : 'h2'}>{t('retrofit-check.not-available.farm-master.headline')}</Typography>
      </Box>
      <Typography variant="body2">{t('retrofit-check.not-available.farm-master.text')}</Typography>
    </>
  )
}

export default FarmMasterWarning
